import { nanoid } from 'nanoid/non-secure';  // Using non-secure for browser compatibility

// Generate unique receipt ID
export const generateReceiptId = () => {
  const timestamp = new Date().getTime();
  const uniqueId = nanoid(8);  // 8-character unique ID
  return `RCP-${timestamp}-${uniqueId}`;
};

// Email receipt function
export const emailDonationReceipt = async (donationData, cause) => {
  try {
    const response = await fetch('/api/email-receipt', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        donationData,
        cause
      })
    });
    
    if (!response.ok) {
      throw new Error('Failed to send receipt email');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error sending receipt:', error);
    throw error;
  }
};

// Format currency
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(amount);
};

// Format date for Central Time
export const formatDate = (date) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'America/Chicago'
  }).format(new Date(date));
}; 